<template>
    <v-dialog v-model="viewAppointmentModal" max-width="500px" content-class="class-modal">
        <v-card class="view-panel">
             <div class="modal-header">
                <h4 v-show="eventLoading === false" class="modal-headline">
                    {{ course.title }}
                </h4>
                 <div class="tools"> 
                    <v-btn icon @click="viewAppointmentModal = false"><v-icon>mdi-close</v-icon></v-btn>
                 </div>
             </div>
            <v-card-text>
                <div class="info-container" style="min-height:100px">
                    <template>
                        <v-sheet>
                            <v-skeleton-loader
                            type="article, article" 
                            v-show="eventLoading === true"
                            :loading="eventLoading === true"
                            ></v-skeleton-loader>
                        </v-sheet>
                    </template>
                    <div v-show="eventLoading === false" transition="fade-transition">
                        <div class="grid">
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-calendar-text-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.date || "Date" }}</p>
                                    <p class="value">{{ course.start | formatDate }}</p>
                                </div>
                            </div>
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-clock-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.time || "Time" }}</p>
                                    <p class="value">{{ course.start | formatTime }} - {{ course.end | formatTime }}</p>
                                </div>
                            </div>
                            <div class="info-group" v-if="course.location != null">
                                <div class="icon-wrap"><v-icon>mdi-map-marker-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.location || "Location" }}</p>
                                    <p class="value">{{ course.location.name }}</p>
                                </div>
                            </div>
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-account-circle-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.trainer || "Trainer" }}</p>
                                    <p class="value">{{ course.trainer.full_name }}</p>
                                </div>
                            </div>
                            <div class="info-group">
                                <div class="icon-wrap"><v-icon>mdi-account-multiple-check-outline</v-icon></div>
                                <div class="info-wrap">
                                    <p class="label">{{ $page.props.lang.booked || "Booked" }}</p>
                                    <p class="value">{{ course.booked_seats }}/{{ course.max_seats }}</p>
                                </div>
                            </div>
                        </div>
                        <div>
                           
                            <v-data-table 
                                            hide-default-header 
                                            hide-default-footer 
                                           :headers="[
                                                { text: 'Ime', value: 'full_name', align: 'start' },
                                               
                                            ]"
                                            :items="course.participants">
                                            <template v-slot:item.full_name="{ item }">
                                                    <v-avatar size="40">
                                                        <img :src="item.profile_photo" alt="">
                                                    </v-avatar>
                                                    <div style="display:inline-block; line-height:1em">
                                                        {{ item.full_name }}<br>
                                                        <span style="color: #444; font-size:10px">{{item.membership}}</span>
                                                    </div>
                                                 
                                            </template>
                                        </v-data-table>
                        </div>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="book(course.id)" :loading="addEventLoading" 
                :disabled="!course.can_book">{{ $page.props.lang.book || "Book" }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EventBus from '../../../../eventbus';

export default {
    props: {
        open: Boolean,
        course: Object,
    },
    data(){
        return{
            eventLoading: false,
            messageObjects: [],
            addEventLoading: false
        }
    },
    computed: {
        viewAppointmentModal: {
            get: function() {
                return this.open
            },
            set: function(newValue) {
                EventBus.$emit('CLOSE_CLASS_MODAL');
                return newValue;
            }
        }
    }, 
    methods: {
        book(id){
            this.addEventLoading = true
            axios.post('/portal/calendar/book', {class_id: id})
            .then((r) => {
                let messageType = "success"
                if(r.data.status==="OK"){
                    this.$inertia.reload({only:['appointments', 'classes']})
                    this.viewAppointmentModal = false
                    this.addEventLoading = false
                } else {
                    messageType = "error"
                }

                EventBus.$emit('SHOW_NOTIFICATION', {
                        message: r.data.message,
                        color: messageType,
                        timeout: 5000
                });
            })
            .catch((e) =>{
                this.addEventLoading = false;

                if(e.response.status == 422){
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: e.response.data.errors.session[0],
                        color: 'error',
                        timeout: 5000
                });
                }
            });
        }
    }
}
</script>